import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import authService from '@/services/authService'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token') ?? sessionStorage.getItem('token') ?? null)
  const user  = ref(JSON.parse(localStorage.getItem('user') ?? sessionStorage.getItem('user') ?? 'null'))

  const isAuthenticated = computed(() => !!token.value)

  async function login(email, password, remember = false) {
    const data = await authService.login(email, password, remember)
    token.value = data.token
    user.value  = data.user
    const storage = remember ? localStorage : sessionStorage
    storage.setItem('token', data.token)
    storage.setItem('user', JSON.stringify(data.user))
    if (!remember) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  }

  async function register(payload) {
    // Returns { message, email } — no token until email is verified
    return await authService.register(payload)
  }

  async function verifyEmail(email, code) {
    const data = await authService.verifyEmail(email, code)
    token.value = data.token
    user.value  = data.user
    localStorage.setItem('token', data.token)
    localStorage.setItem('user', JSON.stringify(data.user))
  }

  function logout() {
    token.value = null
    user.value  = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('user')
  }

  return { token, user, isAuthenticated, login, register, verifyEmail, logout }
})
